import AtAGlanceModal from './AtAGlanceModal';
import React, { useEffect, useState } from 'react';
import { Combobox } from '@headlessui/react';
import { useNavigate, useLocation } from 'react-router-dom';
import FormSpinner from '../../formComponents/FormSpinner';
import NoRecords from '../../formComponents/NoRecords';

export default function CaregiverReportsTable({ loading, data }) {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState();
  const [displayData, setDisplayData] = useState();

  const handleClick = (item) => {
    setOpen(true);
    setId(item?.id);
  };

  const navigate = useNavigate();
  const location = useLocation();

  const navigateToForm = (item) => {
    navigate('/mtss/action-details', {
      state: { item: item, from: location.pathname },
    });
  };

  let people = data;
  let treatment = data;

  const [query, setQuery] = useState('');
  const [selectedPerson, setSelectedPerson] = useState();

  let filteredPeople =
    query === ''
      ? people
      : people?.filter((person) => {
          return person?.student?.last_name
            .toLowerCase()
            .includes(query.toLowerCase());
        });

  const filterByStudent = () => {
    setDisplayData(
      filteredPeople
        ?.slice()
        .sort((a, b) => (a.student?.last_name > b.student?.last_name ? 1 : -1)),
    );
  };

  const filteredTreatments =
    query === ''
      ? treatment
      : treatment?.filter((treatment) => {
          return treatment?.intervention?.treatment?.treatment_name
            .toLowerCase()
            .includes(query.toLowerCase());
        });

  const filterByTreatment = () => {
    setDisplayData(
      filteredTreatments
        ?.slice()
        .sort((a, b) =>
          a.treatment?.intervention?.treatment?.treatment_name >
          b.treatment?.intervention?.treatment?.treatment_name
            ? 1
            : -1,
        ),
    );
  };

  useEffect(() => {
    setDisplayData(filteredPeople);
  }, [query, people]);

  return (
    <div className='px-4 sm:px-6 lg:px-8'>
      <div className='sm:flex sm:items-center'></div>
      <div className='mt-12 flex flex-col items-center justify-between sm:mt-16 lg:mt-20 lg:flex-row'>
        <div className='w-full lg:max-w-sm'>
          <Combobox
            as='div'
            value={selectedPerson}
            onChange={setSelectedPerson}
          >
            <div className='relative mt-2'>
              <Combobox.Input
                className='w-full rounded-md border-2 border-gray-200 bg-white py-3 pl-3 pr-10 text-brandText  focus:border-brandPrimary focus:outline-none focus:ring-1 focus:ring-brandPrimary sm:text-sm'
                onChange={(event) => setQuery(event.target.value)}
                displayValue={(person) => person?.first_name}
                autoComplete='off'
                onBlur={() => {
                  filteredPeople = people;
                  setQuery('');
                }}
                placeholder='Filter by Last Name'
              />
            </div>
          </Combobox>
        </div>
        <div className='mt-5 flex w-full flex-row lg:mt-0 lg:w-auto'>
          <button
            className='mr-3 flex w-full items-center justify-center whitespace-nowrap rounded-md border-2 border-transparent bg-brandPrimary px-4 py-2 text-base font-medium text-white shadow-sm duration-300 ease-in-out hover:scale-110 hover:bg-brandPrimaryLight focus:border-brandPrimary focus:outline-none focus:ring-1 focus:ring-brandPrimary lg:w-auto'
            onClick={() => {
              filterByStudent();
            }}
          >
            Sort by Student
          </button>
          <button
            className='flex w-full items-center justify-center whitespace-nowrap rounded-md border-2 border-transparent bg-brandPrimary px-4 py-2 text-base font-medium text-white shadow-sm duration-300 ease-in-out hover:scale-110 hover:bg-brandPrimaryLight focus:border-brandPrimary focus:outline-none focus:ring-1 focus:ring-brandPrimary lg:w-auto'
            onClick={() => {
              filterByTreatment();
            }}
          >
            Sort by Treatment
          </button>
        </div>
      </div>
      <div className='-mx-4 mt-5 overflow-hidden shadow-lg ring-1 ring-gray-100 sm:-mx-6 md:mx-0 md:mt-5 md:rounded-lg'>
        <table className='min-w-full divide-y divide-gray-100'>
          <thead className='bg-brandPrimary'>
            <tr>
              <th
                scope='col'
                className='py-3.5 pl-4 pr-3 text-left text-lg font-bold text-white sm:pl-6'
              >
                Date
              </th>
              <th
                scope='col'
                className='hidden px-3 py-3.5 text-left text-lg font-bold text-white lg:table-cell'
              >
                Student
              </th>
              <th
                scope='col'
                className='hidden px-3 py-3.5 text-left text-lg font-bold text-white sm:table-cell'
              >
                Treatment
              </th>
              <th
                scope='col'
                className='px-3 py-3.5 text-left text-lg font-bold text-white'
              >
                Comment
              </th>
              <th scope='col' className='relative py-3.5 pl-3 pr-4 sm:pr-6'>
                <span className='sr-only'>Edit</span>
              </th>
            </tr>
          </thead>
          <tbody className='divide-y divide-gray-100 bg-white'>
            {displayData?.map((item, itemIdx) => (
              <tr key={itemIdx}>
                <td className='w-full max-w-0 py-4 pl-4 pr-3 text-sm font-normal text-brandText sm:w-auto sm:max-w-none sm:pl-6'>
                  {item?.intervention?.start_date}
                  <dl className='font-normal lg:hidden'>
                    <dt className='sr-only'>Student</dt>
                    <dd className='mt-1 truncate text-brandPrimary'>
                      <button
                        className='rounded-md hover:text-brandPrimaryLight focus:border-brandPrimary focus:outline-none focus:ring-2 focus:ring-brandPrimary'
                        onClick={() => {
                          handleClick(item?.student);
                        }}
                      >
                        {item?.student?.first_name +
                          ' ' +
                          item?.student?.last_name}
                      </button>
                    </dd>
                    <dt className='sr-only sm:hidden'>Issue</dt>
                    <dd className='mt-1 truncate text-brandText sm:hidden'>
                      {item?.intervention?.treatment?.treatment_name}
                    </dd>
                  </dl>
                </td>

                <td className='hidden px-3 py-4 text-sm font-normal text-brandPrimary hover:text-brandPrimaryLight lg:table-cell'>
                  <button
                    className='rounded-md duration-300 ease-in-out hover:scale-110 focus:border-brandPrimary focus:outline-none focus:ring-2 focus:ring-brandPrimary'
                    onClick={() => {
                      handleClick(item?.student);
                    }}
                  >
                    {item?.student?.first_name + ' ' + item?.student?.last_name}
                  </button>
                </td>

                <td className='hidden px-3 py-4 text-sm font-normal text-brandText sm:table-cell'>
                  {item?.intervention?.treatment?.treatment_name}
                </td>
                <td className='px-3 py-4 text-sm font-normal text-gray-500'>
                  {item?.comment_text}
                </td>
                <td className='py-4 pl-3 pr-4 text-right text-sm font-medium duration-300 ease-in-out hover:scale-110 sm:pr-6'>
                  <button
                    onClick={() => {
                      navigateToForm(item?.intervention);
                    }}
                    className='font-medium text-brandPrimary hover:text-brandPrimaryLight'
                  >
                    View Action<span className='sr-only'>View Action</span>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <FormSpinner loading={loading} />
        <NoRecords loading={loading} data={displayData} />
      </div>
      <AtAGlanceModal open={open} setOpen={setOpen} id={id} />
    </div>
  );
}
